import React from 'react';
import { FONT_MONO } from 'Utils/styleTokens';

/**
 * Stacked horizontal funnel pill (mockups 2a / 3a headers): proportional colored
 * segments plus a trailing mono label. Segments with zero weight are skipped.
 *
 * @param segments [{ label, value, color }]
 * @param caption  optional leading label (e.g. "Protection funnel:")
 * @param trailing trailing mono text (e.g. "13% masked")
 */
function FunnelBar({ segments, caption, trailing, width = 300 }) {
  const total = (segments || []).reduce((a, s) => a + (s.value > 0 ? s.value : 0), 0);
  if (total <= 0) return null;
  return (
    <div className='d-flex align-items-center' style={{ gap: 8 }}>
      {caption && (
        <span className='sg-small' style={{ color: 'var(--ink-500)', whiteSpace: 'nowrap' }}>
          {caption}
        </span>
      )}
      <div
        className='d-flex'
        style={{ width, height: 12, borderRadius: 'var(--r-full)', overflow: 'hidden', flex: 'none' }}
      >
        {segments
          .filter((s) => s.value > 0)
          .map((s) => (
            <div
              key={s.label}
              title={`${s.label}: ${s.value} (${Math.round((s.value / total) * 100)}%)`}
              style={{ width: `${(s.value / total) * 100}%`, background: s.color }}
            />
          ))}
      </div>
      {trailing && (
        <span className='sg-small' style={{ fontFamily: FONT_MONO, color: 'var(--ink-500)', whiteSpace: 'nowrap' }}>
          {trailing}
        </span>
      )}
    </div>
  );
}

export default FunnelBar;
